// @ts-nocheck
import { httpClient } from '../../../core/network';
import { SERVER_URL } from '../../../config';

class VoucherService {
  static fetchVoucher(voucherNo) {
    const apiUrl = `/vouchers/${voucherNo}`;
    return httpClient.get(apiUrl);
  }

  static downloadMultiVouchers(campaignSeriesId) {
    const accessToken = localStorage.getItem('access_token');
    const idToken = localStorage.getItem('id_token');
    return `${SERVER_URL}series/${campaignSeriesId}/users?access_token=${accessToken}&id_token=${idToken}`;
  }
}

export default VoucherService;
